




































import Vue from 'vue'
import releaseNotes from '@/ReleaseNotes'
import './UserMenu.scss'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend({
  name: 'UserMenu',
  props: {
    username: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: false
    },
    inCast: {
      type: Boolean,
      required: false,
      default: false
    },
    currentVersion: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    menuOpen: false
  }),
  computed: {
    commitId (): string {
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
        return releaseNotes().commitId || ''
      }
      return ''
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    closeMenu () {
      if (this.menuOpen) {
        this.menuOpen = false
      }
    },
    toggleProfile (payload: boolean): void {
      this.$store.direct.dispatch.user.toggleProfileModal(payload)
    },
    logOut () {
      this.$router.push({ path: '/logout' })
    },
    leaveCast () {
      this.$emit('leaveCast')
    }
  }
})
